import { render, staticRenderFns } from "./piweb-rodape.vue?vue&type=template&id=bd6d570e&scoped=true&"
import script from "./piweb-rodape.vue?vue&type=script&lang=js&"
export * from "./piweb-rodape.vue?vue&type=script&lang=js&"
import style0 from "./piweb-rodape.vue?vue&type=style&index=0&id=bd6d570e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6d570e",
  null
  
)

export default component.exports